export const whatsapp = {
	section: {
		header: {
			model: "Modelo",
			goBack: "Volver y seleccionar otro modelo",
			editTitle: "Editar mensaje WhatsApp",
		},
		tags: {
			approvedModel: "Modelo aprobado",
			modelInValidation: "Modelo en validación",
			modelRefused: "Modelo no aprobado por WhatsApp",
			modelRecieved: "Modelo recibido por WhatsApp",
		},
		form: {
			title: "Defina los parámetros del mensaje",
			checkboxLabel: "Utilizar nombre del cliente desde la base de datos",
			checkboxObservationLabel: "Utilizar campo observación desde la base de datos",
			previewTitle: "Vista previa del mensaje",
		},
		footer: {
			btnUnderstandWhy:
				"Entienda por qué solo puede enviar mensajes de WhatsApp a partir de modelos",
			btnRequestNewModel: "Solicitar nuevo modelo",
		},
		understandWhyModal: {
			title:
				"Entienda por qué solo puede enviar mensajes de WhatsApp a partir de modelos",
			text:
				"WhatsApp y Facebook tienen políticas claras de uso. Todo el contenido de comunicación que pasa por la plataforma debe ser revisado y aprobado para garantizar que no viole las políticas de WhatsApp. Para garantizar que sus políticas no sean violadas, solo podrá iniciar conversaciones utilizando este modelo de mensaje. Facebook tiene el derecho de revisar y rechazar los modelos de mensaje en cualquier momento.",
			understandButton: "Entendido",
		},
		emptyTemplateState: {
			title: "Ninguna plantilla registrada",
			text:
				"Solicite una nueva plantilla para enviar mensajes de WhatsApp a sus clientes",
		},
	},
	newTemplatePage: {
		header: {
			title: "Solicitar nuevo modelo para",
			subtitle: {
				text:
					"La solicitud del nuevo modelo puede demorar algunos días. Escriba abajo lo que desea incluir en su nuevo modelo.",
				link: "Recuerde siempre seguir las directrices de contenido de WhatsApp",
			},
		},
		removeFileButtonLabel: "Haga clic aquí para adjuntar una imagen",
		messageErrorUpload: "El adjunto debe ser de tipo imagen.",
		invalideVariableMessage: "Debe utilizar una de las variables del glosario",
		modelTitle: "Título del modelo",
		modelTitleTooltipMessage: "Informe un título para su plantilla",
		modelTitlePlaceholder: "Escriba el título",
		imageLabel: "Imagen",
		imageTooltipMessage: "Adjunte una imagen para enviar en su plantilla",
		textareaLabel: "Contenido del mensaje",
		textareaTooltipMessage: "Escriba el contenido del modelo que le gustaría crear",
		textareaPlaceholder:
			"Escriba el contenido del modelo aquí. Consejo: para agregar variables y poder modificarlas en el futuro, siga el glosario al lado.",
		glossaryVariables: {
			date: "fecha",
			client: "cliente",
			productName: "producto-nombre",
			productOriginalPrice: "producto-precio-original",
			productPromotionalPrice: "producto-precio-promocional",
			discount: "promocion-descuento",
			observation: "observacion",
		},
		glossary: {
			title: "Glosario de variables",
			description:
				'Para poder reutilizar este modelo, escriba el código abajo entre corchetes como en el ejemplo: "[{{variable}}]"',
			date: {
				name: "Período",
				description: "Día de la semana o fecha específica",
			},
			client: {
				name: "Nombre del cliente",
				description: "Nombre del cliente",
			},
			productName: {
				name: "Nombre del producto específico",
				description: "Nombre del producto",
			},
			discount: {
				name: "Porcentaje de descuento",
				description: "Valor porcentual del descuento",
			},
			originalProductPrice: {
				name: "Precio del producto",
				description: "Precio original del producto específico",
			},
			productPromotionalPrice: {
				name: "Precio promocional del producto",
				description: "Precio promocional del producto específico",
			},
			observation: {
				name: "Observación",
				description: "Observación",
			},
		},
		warning: {
			responseDeadline: "Plazo de respuesta",
			description:
				"WhatsApp puede demorar hasta 3 días para autorizar el nuevo modelo. Durante este período puede enviar otros mensajes a partir de los otros modelos del área anterior.",
		},
		footer: {
			title: "Vista previa del mensaje",
			newModelButton: "Solicitar nuevo modelo",
		},
	},
	contentControlModal: {
		title: "Control de contenido",
		paragraph1: {
			text:
				"WhatsApp y Facebook tienen políticas claras de uso. Todo el contenido de comunicación que pasa por la plataforma debe ser revisado y aprobado para garantizar que no viole las políticas de WhatsApp. A continuación, tenemos algunos usos prohibidos extraídos de la propia documentación de la",
			textLink:
				"Política de WhatsApp Business. Para leer la documentación completa, haga clic aquí",
		},
		paragraph2: {
			text:
				"Considerando el contexto en el que ZigPay actúa, debemos dejar claras algunas de las políticas contenidas en la documentación de política comercial de WhatsApp que probablemente interfieren en lo que puede divulgar en la plataforma. Listamos algunas abajo, pero es muy importante que lea la",
			textLink: "documentación completa de política comercial.",
		},
		alcoholicBeverages: "Bebidas alcohólicas",
		paragraph3: {
			text: "las empresas no pueden vender o promover la venta de bebidas alcohólicas",
			politicsBold: "Política:",
			exampleBold: "Ejemplos:",
		},
		paragraph4: {
			text:
				"divulgaciones sobre libros o DVDs sobre bebidas alcohólicas. O Items relacionados con bebidas alcohólicas como copas, refrescos y soportes para botellas de vino.",
			areAllowedBold: "Están permitidas",
		},
		paragraph5: {
			text:
				"divulgaciones sobre bebidas alcohólicas o kits para producción de bebidas alcohólicas.",
			areNotAllowedBold: "No están permitidas",
		},
		confirmation: {
			paragraph:
				"Facebook tiene políticas sobre el tipo de contenido divulgado por WhatsApp. ¿Confirma que leyó las ",
			underlined:
				"políticas y está consciente de lo que puede y no puede ser divulgado por la plataforma?",
			label:
				"Confirmo que leí las políticas de WhatsApp Business y estoy consciente de lo que puede ser divulgado.",
		},
	},
	actionButtons: {
		title: "Botones - Opcional",
		subTitle:
			"Son botones que aparecen como opciones clicables justo después de su mensaje",
		addbutton: "Agregar otro botón",
		noneButton: "Ninguno",
		actionButton: "Acciones",
		quickResponseButton: "Respuesta rápida",
		quickResponseAction: {
			title: "Respuesta rápida {{numbering}}",
			placeholderQuickResponse: "Escriba aquí la respuesta rápida",
		},
		optionsAction: {
			label: {
				typeAction: "Tipo de acción",
				makeCall: "Hacer llamada",
				accessWebsite: "Acceder al sitio",
				phoneNumber: "Número de teléfono",
				buttonText: "Texto del botón",
				country: "País",
				websiteLink: "Link del sitio",
			},
			placeholder: {
				callNow: "Llamar ahora",
				enterNumber: "Ingrese el número aquí",
				accessWebsite: "Acceda a nuestro sitio",
				insertLink: "Ingrese el link aquí",
			},
		},
		validationFields: {
			requiredField: "Campo obligatorio {{field}}",
		},
		formatValidation: {
			phoneNumber: "Número de teléfono inválido",
			url: "Link inválido",
		},
	},
};
